<template>
  <div class="mobile-header">
    <div class="mobile-header-container col-12 col-md-10 px-0">
      <div class="d-flex align-items-center">
        <i class="ham-icon mr-2" @click="showSidebar = true"></i>
        <span class="heading bold" v-if="heading" :class="headerClass">{{ heading }}</span>
        <span class="heading bold" v-else-if="team">{{ team.name }}</span>
        <span class="shine-container" v-else><span class="shine"></span></span>
      </div>
      <timeline-dropdown
        v-if="showTimelineDropdown"
        :intervals="intervals"
        :selected-interval="selectedInterval"
        :team-id="teamId"
        @change="$emit('update:selectedInterval', $event)"
      />
      <div v-if="showSidebar" class="mobile-sidebar">
        <sidebar :org-id="orgId" :show-close="true" @close="showSidebar = false" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * This is the header with Hamburger menu. It will be mainly used in small screens (In place of Desktop)
 *
 * This should be rendered only if `MediaQueryMixin.isDesktopMode` is false.
 */
import TimelineDropdown from '@/components/TimelineDropdown'
import Sidebar from '@/components/sidebar/Sidebar'
export default {
  name: 'MobileHeader',
  props: {
    orgId: Number,
    teamId: [String, Number],
    selectedInterval: Object,
    intervals: Array,
    heading: String,
    headerClass: { default: '' },
    showTimelineDropdown: { default: true }
  },
  data() {
    return {
      showSidebar: false
    }
  },
  components: {
    TimelineDropdown,
    Sidebar
  },
  computed: {
    org() {
      return this.$store.getters.orgById(this.orgId)
    },
    team() {
      return this.$store.getters.teamById(this.teamId)
    }
  },
  methods: {
    async fetchTeam() {
      if (this.teamId && !this.$store.getters.teamById(this.teamId)) {
        await this.$store.dispatch('getTeam', { orgId: this.orgId, teamId: this.teamId })
      }
    }
  },
  mounted() {
    this.fetchTeam()
  },
  watch: {
    teamId() {
      this.fetchTeam()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.heading {
  font-size: 1.5rem;
}

.mobile-header {
  padding: 20px 0;
  display: flex;
  justify-content: center;
  position: sticky;
  top: 0;
  background-color: $documentColor;
  z-index: 3;
}
.mobile-header-container {
  display: flex;
  justify-content: space-between;
}

.ham-icon {
  background-position: -2px 2px;
}

.mobile-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $documentColor;
  z-index: 10000;
}
.shine {
  height: 15px;
  width: 120px;
  border-radius: 10px;
}
.shine-container {
  height: 36px;
  display: flex;
  align-items: center;
}
</style>
